(function() {
  'use strict';

  let ytSwiperInstance = null;
  const SECTION_ID = 'ytCarouselSection';
  const SWIPER_CLASS = 'yt-carousel-swiper';


  function extractYouTubeId(url) {
    if (!url) return null;
    const patterns = [
      /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/,
      /youtube\.com\/embed\/([^&\n?#]+)/,
      /youtube\.com\/v\/([^&\n?#]+)/
    ];
    
    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match) return match[1];
    }
    return null;
  }


  function openVideoModal(videoUrl) {
    const videoId = extractYouTubeId(videoUrl);
    if (!videoId) {
      return;
    }

    const modal = document.getElementById('ytVideoModal');
    const iframe = document.getElementById('ytVideoIframe');
    

    const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&controls=1&fs=1`;
    

    modal.classList.add('yt-modal-active');
    document.body.classList.add('yt-video-modal-open');
    

    setTimeout(() => {
      iframe.src = embedUrl;
    }, 50);
  }


  function closeVideoModal() {
    const modal = document.getElementById('ytVideoModal');
    const iframe = document.getElementById('ytVideoIframe');
    
    modal.classList.remove('yt-modal-active');
    iframe.src = '';
    document.body.classList.remove('yt-video-modal-open');
  }


  function checkCarouselVisibility() {
    const section = document.getElementById(SECTION_ID);
    if (!section) return;

    const swiperEl = section.querySelector('.' + SWIPER_CLASS);
    const slides = section.querySelectorAll('.yt-carousel-slide');


    if (!swiperEl || slides.length === 0) {
      section.classList.add('yt-carousel-hidden');
      return false;
    }

    section.classList.remove('yt-carousel-hidden');
    return true;
  }

function initSwiper() {
  const swiperEl = document.querySelector('.' + SWIPER_CLASS);
  if (!swiperEl) return;

  if (ytSwiperInstance) {
    ytSwiperInstance.destroy(true, true);
    ytSwiperInstance = null;
  }

  const slidesCount = parseInt(swiperEl.dataset.videosCount || '0');
  const isMobile = window.innerWidth < 768;
  const slidesPerView = isMobile ? 1.5 : 4;


  const isScrollable = slidesCount > slidesPerView;

  ytSwiperInstance = new Swiper('.' + SWIPER_CLASS, {
    slidesPerView: slidesPerView,
    spaceBetween: 24,
    breakpoints: {
      320: { slidesPerView: 1.5, spaceBetween: 12 },
      768: { slidesPerView: 3, spaceBetween: 20 },
      1024: { slidesPerView: 4, spaceBetween: 24 },
      1440: { slidesPerView: 5, spaceBetween: 24 }
    },
    pagination: isScrollable ? {
      el: '.yt-carousel-pagination',
      clickable: true,
      type: "progressbar"
    } : false,  
    navigation: false,
    on: {
      init: updateNavButtons,
      slideChange: updateNavButtons
    }
  });

  updateNavButtons();
}

  function updateNavButtons() {
    if (!ytSwiperInstance) return;

    const section = document.getElementById(SECTION_ID);
    if (!section) return;

    const prevBtn = section.querySelector('.yt-carousel-btn-prev');
    const nextBtn = section.querySelector('.yt-carousel-btn-next');


    const isScrollable = !(ytSwiperInstance.isBeginning && ytSwiperInstance.isEnd);

    if (!isScrollable) {
   
      if (prevBtn) prevBtn.classList.add('yt-btn-hidden');
      if (nextBtn) nextBtn.classList.add('yt-btn-hidden');
    } else {
 
      if (prevBtn) {
        prevBtn.classList.remove('yt-btn-hidden');
        prevBtn.disabled = ytSwiperInstance.isBeginning;
      }
      if (nextBtn) {
        nextBtn.classList.remove('yt-btn-hidden');
        nextBtn.disabled = ytSwiperInstance.isEnd;
      }
    }
  }


  document.addEventListener('DOMContentLoaded', function() {

    if (!checkCarouselVisibility()) {
      return;
    }

    initSwiper();

    const section = document.getElementById(SECTION_ID);
    if (!section) return;


    section.querySelector('.yt-carousel-btn-prev')?.addEventListener('click', () => {
      if (ytSwiperInstance && !ytSwiperInstance.isBeginning) {
        ytSwiperInstance.slidePrev();
      }
    });

  
    section.querySelector('.yt-carousel-btn-next')?.addEventListener('click', () => {
      if (ytSwiperInstance && !ytSwiperInstance.isEnd) {
        ytSwiperInstance.slideNext();
      }
    });

    section.querySelectorAll('.yt-carousel-slide').forEach(slide => {
      slide.addEventListener('click', function(e) {
    
        if (e.target.closest('.yt-video-thumbnail-card')) {
          const videoUrl = this.dataset.videoUrl;
          if (videoUrl) {
            openVideoModal(videoUrl);
          }
        }
      });
    });


    document.querySelector('.yt-video-modal-close')?.addEventListener('click', closeVideoModal);

    document.getElementById('ytVideoModal')?.addEventListener('click', function(e) {
      if (e.target === this) {
        closeVideoModal();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        const modal = document.getElementById('ytVideoModal');
        if (modal?.classList.contains('yt-modal-active')) {
          closeVideoModal();
        }
      }
    });
  });

  window.addEventListener('resize', function() {
    initSwiper();
  });
})();


(function() {
  'use strict';
  
  
  const videoSelector = '#ytCarouselSection';
  const productSelector = '.product.product_main.product--small.product--left.product--stacked.product--mobile-show';
  
  let hasReordered = false;
  
  function reorderNow() {
    if (hasReordered) return;
    
    const video = document.querySelector(videoSelector);
    const product = document.querySelector(productSelector);
    
    
    if (!video || !product) return false;
    
    try {

      product.insertAdjacentElement('afterend', video);
      hasReordered = true;
      return true;
    } catch (e) {
      return false;
    }
  }
  

  if (document.readyState !== 'loading') {
    reorderNow();
  }
  

  if (!hasReordered) {
    document.addEventListener('DOMContentLoaded', reorderNow);
    window.addEventListener('load', reorderNow);
    

    const checkInterval = setInterval(() => {
      if (reorderNow()) {
        clearInterval(checkInterval);
      }
    }, 200);
    
    setTimeout(() => clearInterval(checkInterval), 5000);
  }
  

  window.checkReorder = function() {
    return {
      reordered: hasReordered,
      videoFound: !!document.querySelector(videoSelector),
      productFound: !!document.querySelector(productSelector),
    };
  };
})();
